module.exports = __webpack_public_path__ + "img/athena_logo_triangle_2000.bd4527c6.png";